module.exports = __webpack_public_path__ + "img/report-request-await.206ebd4e.png";